import React, { memo, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import styles from './SoftCardSearchHot.module.less';
import { setHotLenovoVisible } from '../../actions/layout';
import { getSoftType } from '../../utils/utils';

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();

  // 1. 联系词softcard 做特殊处理 (即：将其作为搜索结果点击进入详情处理)
  // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
  // 详情页中通过source_p==='Search'判断来源是否来自搜索
  const handleSoftCard = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfo.source_p,
          source_pp: logInfo.source_pp,
          cardName: 'SoftCardSearchHot',
          softType: getSoftType(soft),
          softid: soft.androidType === '1' ? soft?.packageName : soft?.softID,
          search_word: '',
          search_type: logInfo?.search_type,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source: logInfo.source,
        source_p: logInfo.source_p,
        source_pp: logInfo.source_pp,
      }),
    );
    dispatch(setHotLenovoVisible(-1));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      logging({
        category: 'I',
        action: 'Search_Hot_Firstapp',
        label: '',
        param2: {
          source: logInfo.source,
          search_type: 5,
          softid: soft.androidType === '1' ? soft.packageName : soft.softID,
          softType: getSoftType(soft),
        },
        param3: soft.bizInfo,
      }),
    );
  }, [dispatch, soft]);

  return (
    <div className={styles.soft_card}>
      <Link
        className={styles.soft_card_img_box}
        to={{
          pathname:
            soft.androidType === '1'
              ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
                  '{}'}?isSearch=true`
              : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=true`,
        }}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
      </Link>
      <div className={styles.soft_card_info}>
        <Link
          to={{
            pathname:
              soft.androidType === '1'
                ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
                    '{}'}?isSearch=true`
                : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=true`,
          }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div
            className={styles.soft_card_info_title}
            dangerouslySetInnerHTML={{ __html: soft.softName || soft.softNameShow }}
            title={soft.softName || soft.softNameShow}
          />
        </Link>
        <div
          className={styles.soft_card_opt}
          onClick={e => {
            // e.stopPropagation();
          }}
        >
          {soft.androidType === '1' ? (
            <ApkButton
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
              }}
              // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo, isSearch: true }}
            />
          ) : (
            <Button
              soft={soft}
              info={{
                className: styles.soft_button,
                className_busing: styles.soft_button_busing,
                className_open: styles.soft_button_open,
              }}
              // 联想词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
              logInfo={{ ...logInfo, isSearch: true }}
            />
          )}
        </div>
      </div>
    </div>
  );
});
